import clsx from "clsx";
import React from "react";
import { Table as AntTable } from "antd";
import { useTranslation } from "react-i18next";

import s from "./StaffSummary.less";

interface IStaffSummaryProps {
  number: {
    futureStandard: number;
    standard: number;
    fact: number;
  };
  training: {
    required: { fact: number };
    trained: { fact: number };
  };
  certification: {
    required: { people: number };
    certificated: { people: number };
  };
  licenses?: {
    issued?: { basic?: number | null; additional?: number | null };
    remainder?: { basic?: number | null; additional?: number | null };
  };
}

export const StaffSummary = (props: IStaffSummaryProps) => {
  const { number, training, certification, licenses } = props;
  const { t } = useTranslation();

  return (
    <AntTable.Summary fixed>
      <AntTable.Summary.Row>
        <AntTable.Summary.Cell
          index={0}
          colSpan={3}
          className={s.paddingTableSummary}
        >
          {t("ui.subtotal")}
        </AntTable.Summary.Cell>
        {number &&
          ["futureStandard", "standard", "fact"].map((el, i) => (
            <AntTable.Summary.Cell
              key={i}
              index={3 + i}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {number[el]}
            </AntTable.Summary.Cell>
          ))}
        {training && (
          <>
            <AntTable.Summary.Cell
              index={6}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {training.required.fact}
            </AntTable.Summary.Cell>
            <AntTable.Summary.Cell
              index={7}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {""}
            </AntTable.Summary.Cell>
            <AntTable.Summary.Cell
              index={8}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {training.trained.fact}
            </AntTable.Summary.Cell>
            <AntTable.Summary.Cell index={9} className={s.textCenter}>
              {""}
            </AntTable.Summary.Cell>
          </>
        )}
        {certification && (
          <>
            <AntTable.Summary.Cell
              index={10}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {certification.required.people}
            </AntTable.Summary.Cell>
            <AntTable.Summary.Cell
              index={11}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {""}
            </AntTable.Summary.Cell>
            <AntTable.Summary.Cell
              index={12}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {certification.certificated.people}
            </AntTable.Summary.Cell>
            <AntTable.Summary.Cell
              index={13}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {""}
            </AntTable.Summary.Cell>
          </>
        )}
        {/* TODO PASDILER-2428: итоговые ячейки лицензий временно скрыты до завершения работ в feat/PASDILER-1829. https://task.sotl.group:8443/browse/PASDILER-2428
        {licenses && (
          <>
            <AntTable.Summary.Cell
              index={14}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {formatLicensePair(licenses.issued)}
            </AntTable.Summary.Cell>
            <AntTable.Summary.Cell
              index={15}
              className={clsx(s.textCenter, s.paddingTableSummary)}
            >
              {formatLicensePair(licenses.remainder)}
            </AntTable.Summary.Cell>
          </>
        )} */}
      </AntTable.Summary.Row>
    </AntTable.Summary>
  );
};
